import '../../../core/components/chart-grid/ChartGrid.css';
import './TimeseriesOverlays.css';
export var crosshairLayout = '_1k75lpt2-2-0-1 _2c3zgm0-2-0-1';
export var datapointCanvasPlot = '_1k75lpt0-2-0-1 _2c3zgm0-2-0-1';
export var datapointIndicatorLayout = '_1k75lpt1-2-0-1 _2c3zgm0-2-0-1';